import { hexToBytes } from '@tevm/utils'

// TODO Might want to move these to utils these are getting copy pasted a lot
// kekkak256(null)
export const KECCAK256_NULL = hexToBytes('0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470')
